export const EVENT_WIZARD_URI = 'event/wizard';
/** Leads with a no-break space so a wrapping link never leaves the emoji alone on its own line. */
export const EVENT_PROMOTION_LINK_EMOJI = '\u00A0🎉';
